import { NavLink, useLocation } from 'react-router-dom';
import { ReactComponent as ExternalLinkIcon } from '../../../assets/external-link.svg';

interface SidebarItemProps {
  item: {
    label: string;
    link: string;
    icon: string | React.ReactNode;
    external?: boolean;
  };
  expanded: boolean;
}

export function SidebarItem({ item, expanded }: SidebarItemProps) {
  const location = useLocation();

  const isActive = (path: string) => {
    return location.pathname === path.split('?')[0];
  };

  const baseClasses = 'flex items-center space-x-2 px-2 py-2 rounded-lg transition-colors ';
  const activeClasses = isActive(item.link) ? 'bg-white text-darkBlue' : '';
  const combinedClasses = `${baseClasses} ${activeClasses}`;

  const renderIcon = () => {
  return (
    <div className="w-6 h-6 min-w-6 min-h-6 flex items-center justify-center">
      {typeof item.icon === 'string' ? (
        <img src={item.icon} alt={item.label} className="w-5 h-5" />
      ) : (
        <span className="w-5 h-5 flex items-center justify-center">{item.icon}</span>
      )}
    </div>
  );
};

  const content = (
    <>
      {renderIcon()}
      {expanded && (
        <>
          <span className="text-sm font-medium">{item.label}</span>
          {item.external && (
            <span className="ml-1 w-4 h-4 flex items-center justify-center">
              <ExternalLinkIcon className="w-4 h-4 text-white" />
            </span>
          )}
        </>
      )}
    </>
  );

  if (item.external) {
    return (
      <a
        href={item.link}
        target="_blank"
        rel="noopener noreferrer"
        className={combinedClasses}
      >
        {content}
      </a>
    );
  }

  return (
    <NavLink
      to={item.link}
      className={combinedClasses}
    >
      {content}
    </NavLink>
  );
}
